import React, { useState, useRef, useEffect } from 'react';
import DepartmentsList from './DepartmentsList';
import ViewDepartment from './ViewDepartment';
import { useTranslation } from 'react-i18next';
import ResizablePanels from '../../components/Layout/ResizablePanels';
import './Users.css';

// Departments management with master-detail view
const Departments = () => {
  const { t } = useTranslation('admin');
  const [selectedDepartmentId, setSelectedDepartmentId] = useState(null);
  const [viewMode, setViewMode] = useState('list'); // Start with 'list' like Users
  const listRef = useRef();
  const viewRef = useRef();

  useEffect(() => {
    updateToolbar(viewMode);
  }, [viewMode, t]);

  const updateToolbar = (mode) => {
    let toolbar = null;

    if (mode === 'list') {
      // List view
      toolbar = (
        <>
          <button className="toolbar-btn" onClick={handleNew}>
            <span className="icon">➕</span> {t('common:ui.new')}
          </button>
          <button className="toolbar-btn" onClick={handleRefresh}>
            <span className="icon">🔄</span> {t('common:ui.refresh')}
          </button>
        </>
      );
    } else if (mode === 'create') {
      // Create mode
      toolbar = (
        <>
          <button className="toolbar-btn primary" onClick={handleSave}>
            <span className="icon">💾</span> {t('common:ui.save')}
          </button>
          <button className="toolbar-btn" onClick={handleCancel}>
            <span className="icon">✖</span> {t('common:ui.cancel')}
          </button>
        </>
      );
    } else if (mode === 'edit') {
      // Edit mode
      toolbar = (
        <>
          <button className="toolbar-btn primary" onClick={handleSave}>
            <span className="icon">💾</span> {t('common:ui.save')}
          </button>
          <button className="toolbar-btn" onClick={handleCancel}>
            <span className="icon">✖</span> {t('common:ui.cancel')}
          </button>
        </>
      );
    } else {
      // View mode
      toolbar = (
        <>
          <button className="toolbar-btn" onClick={handleEdit}>
            <span className="icon">✏️</span> {t('common:ui.edit')}
          </button>
          <button className="toolbar-btn danger" onClick={handleDelete}>
            <span className="icon">🗑️</span> {t('common:ui.delete')}
          </button>
          <button className="toolbar-btn" onClick={handleBack}>
            <span className="icon">⬅️</span> {t('common:ui.back')}
          </button>
        </>
      );
    }

    if (window.setDepartmentsToolbar) {
      window.setDepartmentsToolbar(toolbar);
    }
  };

  const handleSelectDepartment = (departmentId) => {
    setSelectedDepartmentId(departmentId);
    setViewMode('view');
  };

  const handleBack = () => {
    setSelectedDepartmentId(null);
    setViewMode('list');
  };

  const handleNew = () => {
    setSelectedDepartmentId(null);
    setViewMode('create');
  };

  const handleEdit = () => {
    setViewMode('edit');
  };

  const handleCancel = () => {
    if (viewMode === 'create') {
      setViewMode('list');
      setSelectedDepartmentId(null);
    } else {
      setViewMode('view');
    }
  };

  const handleSave = () => {
    if (viewRef.current) {
      viewRef.current.handleSave();
    }
  };

  const handleDelete = () => {
    if (viewRef.current) {
      viewRef.current.handleDelete();
    }
  };

  const handleRefresh = () => {
    if (listRef.current) {
      listRef.current.fetchDepartments();
    }
  };

  const handleDepartmentCreated = (departmentId) => {
    setSelectedDepartmentId(departmentId);
    setViewMode('view');
    if (listRef.current) {
      listRef.current.fetchDepartments();
    }
  };

  const handleSaveComplete = () => {
    setViewMode('view');
    if (listRef.current) {
      listRef.current.fetchDepartments();
    }
  };

  return (
    <div className="departments-page">
      <ResizablePanels
        leftPanel={
          <DepartmentsList
            ref={listRef}
            onSelectDepartment={handleSelectDepartment}
            selectedDepartmentId={selectedDepartmentId}
            onNew={handleNew}
          />
        }
        rightPanel={
          viewMode !== 'list' ? (
            <ViewDepartment
              ref={viewRef}
              departmentId={selectedDepartmentId}
              editMode={viewMode === 'edit'}
              createMode={viewMode === 'create'}
              onBack={handleBack}
              onEdit={handleEdit}
              onSave={handleSaveComplete}
              onCancel={handleCancel}
              onDepartmentCreated={handleDepartmentCreated}
            />
          ) : null
        }
        leftCollapsed={viewMode !== 'list'}
        defaultLeftWidth={40}
        minLeftWidth={30}
        maxLeftWidth={70}
      />
    </div>
  );
};

export default Departments;